export const SET_MESSAGE_SCREEN_BLOCKER_ACTION_TYPE = 'SET_MESSAGE_SCREEN_BLOCKER_TYPE';

export const setMessage = ({ message }) => ({
  type: SET_MESSAGE_SCREEN_BLOCKER_ACTION_TYPE,
  payload: { message },
});
